// ** Service Import
import Service from './service'

// ** Export Service as Api
export default function useApi(overrideConfig) {
	const api = new Service(overrideConfig)

	return {
		api,
	}
}
